import { render, staticRenderFns } from "./EditTaxGroupComponent.vue?vue&type=template&id=ed182332&"
import script from "./EditTaxGroupComponent.vue?vue&type=script&lang=js&"
export * from "./EditTaxGroupComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports